import SockJS from 'sockjs-client'
import Config from '../config/config'

const parseMessage = require('./parse_message')

export default class Client {
  constructor(channel, nickname) {
    this.nickname = nickname
    this.channel = channel
    this.connected = false

    this.setupSocket()
  }

  setupSocket() {
    var sock = new SockJS(Config.ircGateway)
    this.sock = sock

    sock.onmessage = function(e) {
      const trimmedData = e.data.substring(3)
      if (!trimmedData) {
        return
      }

      let command = parseMessage(trimmedData)
      command.timestamp = new Date()
      // console.log(command)

      if (command.command === 'PING') {
        this.onPing(command)
      } else if (command.rawCommand === '001') {
        this.onServerConnect()
      } else if (command.command === 'rpl_endofmotd') {
        this.onSelfChannelJoin()
      } else if (command.command === 'PRIVMSG') {
        if (command.args[1].substring(0, 1) === '\u0001') {
          command.command = 'CTCP'
        }
        this.onMessage(command)
      } else if (command.command === 'NICK') {
        this.sendData(`NAMES ${this.channel}`)
        command.target = this.channel
        // Reroute 437 (Channel unavailable) as an error
      } else if (command.command === '437') {
        command.command = 'ERROR'
        command.args[0] = 'Temporarily cannot join.'
      }

      if (command.command === 'ERROR') {
        this.emitError('ERROR', command)
      } else {
        this.emit(command.command, command)
      }
    }.bind(this)

    sock.onopen = function() {
      sock.send(':0 CONTROL START')
      sock.send(':1')
      this.sendData('HOST irc.servercentral.net:6667')
      this.sendData('ENCODING utf8')
      this.sendData('NICK ' + this.nickname)
      this.sendData('USER cabiner 0 * https://www.the-cabin.com/')
    }.bind(this)

    sock.onclose = function() {
      this.emit('SELFDIDDISCONNECT', null)
      this.emitError('ERROR', null)
    }.bind(this)
  }

  changeNickname(newNickname) {
    this.sendData(`NICK ${newNickname}`)
  }

  onPing(command) {
    this.sendData('PONG ' + command.args[0])
  }

  onServerConnect() {
    this.connected = true
    this.sendData(`JOIN ${Config.channel}`)
    this.emit('SELFDIDCONNECT')
  }

  onSelfChannelJoin() {
    this.emit('SELFDIDJOIN')
  }

  onMessage(event) {}

  sendMessage(target, text) {
    // console.log(target, text)
    const commandString = `PRIVMSG ${target} :${text}`
    const command = parseMessage(commandString)
    command.nick = this.nickname
    command.isMe = true
    this.sendData(commandString)
    this.emit(command.command, command)
  }

  quit(reason) {
    this.sendData(`QUIT :${reason || 'www.the-cabin.com'}`)
  }

  sendAction(target, text) {
    const commandString = `PRIVMSG ${target} :\u0001ACTION ${text}\u0001`
    const command = parseMessage(commandString)
    command.nick = this.nickname
    command.isMe = true
    this.sendData(commandString)
    this.emit(command.command, command)
  }

  sendData(data) {
    const dataString = ':1 ' + data
    this.sock.send(dataString)
  }

  emit(type, data) {
    const event = new CustomEvent(type, { detail: data })
    window.dispatchEvent(event)
  }

  emitError(type, data) {
    if (!this.connected) {
      return
    }

    this.connected = false
    this.emit(type, data)
  }
}



// WEBPACK FOOTER //
// ./src/irc/Client.jsx